import type { FaireProductEntity } from "../../entity_types/product";

export const p_zgaf3eannr: FaireProductEntity = {
  token: "p_zgaf3eannr",
  type: "product",
  name: "Ace Task Pad Notebook Journal",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/9a687691b42d06bfcb60d2359ff244555d4b14fe266d592a54cdda125d9a0a64.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72354f59b52f2cf05ba77e3373924bc2803fed3d659cbfcf3a0c2fc4c1b9c52b.png",
    "https://cdn.faire.com/fastly/ffc407d38e7a142aefdd8bf043ceacc64444b63dab8fd428e6b7f7787202b29e.webp"
  ],
  priceDollars: 11,
  description: "E. Frances Paper + Shorthand Press Task Pad\n\nThe Task Pad by Shorthand Press, the essential list notepad. With a letterpressed cover and beautiful interior pages, this lined rule notebook has checkboxes on each line allowing you to keep your lists all together.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:18.079Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
